import CompanyProfileSerializer from '../serializers/CompanyProfileSerializers';
import {CompanyProfile} from '../types';

import * as api from '../../../../lib/api/v1/index';
import {ApiResponse, ApiResponseError} from '../../../../lib/api/v1/types';

export class CompanyProfileService {
  async get(companyId: string): Promise<ApiResponse<CompanyProfile>> {
    try {
      const response = await api.getCompanyProfile(companyId);
      const body = await response.json();

      if (response.ok) {
        const companyProfile = CompanyProfileSerializer.toObject(body);
        return {
          ok: true,
          data: companyProfile,
          error: undefined,
        };
      }
      return {
        ok: false,
        data: undefined,
        error: body as ApiResponseError,
      };
    } catch (error: any) {
      return {
        ok: false,
        data: undefined,
        error: {
          error_code: 'CLI_0000',
          error_message: 'Web client error',
          extra_details: error.message,
        },
      };
    }
  }

  async patch(companyProfile: CompanyProfile): Promise<CompanyProfile | undefined> {
    try {
      const response = await api.updateCompanyProfile(companyProfile);
      if (response.ok) {
        return await response.json();
      }
      throw new Error('Could not update company profile');
    } catch (error: unknown) {
      console.error('This is the error:', error);
      throw error;
    }
  }

  async updateLogo(companyId: string, logoId: string | null): Promise<ApiResponse<CompanyProfile>> {
    try {
      const response = await api.updateCompanyLogo(companyId, logoId);
      const body = await response.json();

      if (response.ok) {
        const companyProfile = CompanyProfileSerializer.toObject(body);
        return {
          ok: true,
          data: companyProfile,
          error: undefined,
        };
      }
      return {
        ok: false,
        data: undefined,
        error: body as ApiResponseError,
      };
    } catch (error: any) {
      return {
        ok: false,
        data: undefined,
        error: {
          error_code: 'CLI_0000',
          error_message: 'Web client error',
          extra_details: error.message,
        },
      };
    }
  }
}
